// What a character page tells Google and what a searcher sees in the result.
//
// People search "<name> one piece" and want the bounty or the Devil Fruit, so
// the title says the name, the series and which of those two the page holds.
// A search result shows roughly 60 characters of title and 155 of description,
// and cuts the rest mid-word, so the description is built one whole sentence at
// a time and stops before the limit.

// Plenty of entries carry "None" or "Unknown", sometimes with an aside:
// "Unknown (music-based)", "None (ally of the Straw Hats)". None of that
// belongs in a title or a search snippet.
export const realValue = (value) => {
  const text = value ? String(value).trim() : '';
  if (!text || /^[-—?]+$/.test(text) || /^(none|unknown|n\/a|na)\b/i.test(text)) return '';
  return text;
};

export const MAX_DESCRIPTION = 155;

export const characterMeta = (char) => {
  if (!char) return { title: '', description: '', facts: [] };

  const bounty = realValue(char.bounty);
  const fruit = realValue(char.devilFruit);
  const role = realValue(char.role);
  const crew = realValue(char.crew);
  const facts = [bounty ? 'Bounty' : null, fruit ? 'Devil Fruit' : null].filter(Boolean);

  const title = facts.length
    ? `${char.name} (One Piece): ${facts.join(' and ')}`
    : `${char.name} (One Piece) — Character Profile`;

  const opening = role
    ? `${char.name} from One Piece: ${role}${crew ? ` of the ${crew}` : ''}.`
    : `${char.name} from One Piece${crew ? `, ${crew}` : ''}.`;

  const sentences = [
    opening,
    bounty ? `Bounty: ${bounty} berries.` : '',
    fruit ? `Devil Fruit: ${fruit}.` : '',
    'Full profile and story.',
  ].filter(Boolean);

  let description = '';
  sentences.forEach((sentence) => {
    const next = description ? `${description} ${sentence}` : sentence;
    if (next.length <= MAX_DESCRIPTION) description = next;
  });

  return { title, description, facts };
};

export default characterMeta;
